import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { studentURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import AddStudent from "../../Templates/Students/AddStudent/AddStudent";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddStudentPage({ Edit = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();
  const url = `${studentURL}/${id}`;
  const { data, loading, error } = useFetchWhen(
    url,
    Edit && (contextData?.role == "admin" || contextData?.role == "school")
  );
  const [student, setStudent] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setStudent(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "students", data: "" });
  }, []);

  return (
    <AddStudent
      Edit={Edit}
      student={student}
      loading={loading || student == ""}
      url={url}
    />
  );
}

export default AddStudentPage;
